import { useState } from 'react';
import '../styles/SendForm.css';
import '../styles/Common.css';
import { useNavigate } from 'react-router-dom';
import { sendEmailApi } from '../api/email_api';
import { v4 as uuidv4 } from 'uuid';
import { createDigitalRequestApi } from '../api/digital_request_api'; // יש ליצור פונקציה זו ב-api שלך
import Footer from './Footer';

export default function SendForm() {

    const navigate = useNavigate();

    const [emails, setEmails] = useState(['']);
    const [sending, setSending] = useState(false);
    const [success, setSuccess] = useState(null);
    const [error, setError] = useState(null);

    const handleEmailChange = (index, value) => {
        const updated = [...emails];
        updated[index] = value;
        setEmails(updated);
    };
    const handleAddEmail = () => {
        setEmails([...emails, '']);
    };
    const handleRemoveEmail = (index) => {
        setEmails(emails.filter((_, i) => i !== index));
    };

    const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    const handleSend = async () => {
        setSending(true);
        setSuccess(null);
        setError(null);
        if (emails.some(email => !validateEmail(email))) {
            setError('יש להזין כתובת מייל תקינה בכל השדות');
            setSending(false);
            return;
        }
        try {
            for (const email of emails) {
                const token = uuidv4();
                const link = `${window.location.origin}/DigitalForm?token=${token}`;
                await sendEmailApi({
                    to: [email],
                    subject: 'מילוי טופס דיגיטלי',
                    text: `שלום,\nנא למלא את הטופס בקישור הבא:\n${link}`,
                });
            }
            if (emails.length === 1) {
                alert('המייל נשלח בהצלחה');
            } else {
                alert('המיילים נשלחו בהצלחה');
            }
            navigate('/main_screen');
        } catch (err) {
            alert('שליחת המיילים נכשלה');
        } finally {
            setSending(false);
        }
    };

    return (
        <>
           <div className="top-buttons-container" style={{ marginBottom: "1.25rem" }}>
                {/* כפתור חזרה דף אחורה - עם חץ */}
                <button className="round-nav-btn" onClick={() => navigate(-1)} title="חזרה">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#EF5DA8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                        <polyline points="12 5 19 12 12 19"></polyline>
                    </svg>
                </button>
                {/* כפתור דף הבית - עם בית */}
                <button className="round-nav-btn" onClick={() => navigate('/main_screen')} title="דף הבית">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#EF5DA8" strokeWidth="2">
                        <path d="M12 3L2 12h3v7h4v-5h6v5h4v-7h3L12 3z" />
                    </svg>
                </button>
            </div>
            <h2 className="send-email-title" style={{ marginTop: "5rem" }}>שליחת טופס לסיוע</h2>
            <div className="send-email-card">
                <div className="emails-list">
                    {emails.map((email, idx) => (
                        <div className="email-row" key={idx}>
                            <div className='email-row-ipt-cls'>
                                <input
                                    type="email"
                                    className="email-input add-input"
                                    value={email}
                                    onChange={e => handleEmailChange(idx, e.target.value)}
                                    placeholder="הכנס כתובת מייל"
                                    required
                                    pattern="^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$"
                                    title="נא להזין כתובת מייל תקינה"
                                />
                                {emails.length > 1 && (
                                    <button className="close-btn btn" id="remove-email-btn" onClick={() => handleRemoveEmail(idx)} title="הסר מייל">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <line x1="18" y1="6" x2="6" y2="18" />
                                            <line x1="6" y1="6" x2="18" y2="18" />
                                        </svg>
                                    </button>
                                )}
                            </div>
                            {!validateEmail(email) && email && (
                                <div className='error-msg-container'>
                                    <span className="error-msg">כתובת לא תקינה</span>
                                </div>
                            )}
                        </div>

                    ))}
                    <button className="add-btn" onClick={handleAddEmail} type="button">הוסף מייל נוסף</button>
                </div>
                <button className="send-btn" onClick={handleSend} disabled={sending || emails.some(e => !e)}>
                    {sending ? 'שולח...' : 'שלח לינק למילוי טופס'}
                </button>
                {success && <div className="success-msg">{success}</div>}
                {error && <div className="error-msg">{error}</div>}
                <Footer />
            </div>
        </>
    );
}

